import React from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, Button } from '@components';

interface ConfirmDeleteModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  // Rendered as: "<question> “<itemName>”?"
  question: string;
  itemName: string;
  warning: string;
  confirmLabel: string;
  isDeleting?: boolean;
  // Material icon in the header and on the confirm button
  icon?: string;
}

export const ConfirmDeleteModal: React.FC<ConfirmDeleteModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  question,
  itemName,
  warning,
  confirmLabel,
  isDeleting = false,
  icon = 'delete',
}) => {
  const { t } = useTranslation();

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="" size="sm" showCloseButton={false}>
      <div className="text-center space-y-6">
        <div className="mx-auto w-16 h-16 bg-red-50 dark:bg-red-900/20 rounded-full flex items-center justify-center">
          <span className="material-icons text-3xl text-red-600 dark:text-red-400">
            {icon === 'delete' ? 'delete_forever' : icon}
          </span>
        </div>

        <div className="space-y-3">
          <h3 className="text-xl font-semibold text-gray-900 dark:text-white">{title}</h3>
          <p className="text-gray-600 dark:text-gray-400 leading-relaxed break-words">
            {question}{' '}
            <span className="font-semibold text-gray-900 dark:text-white">
              &ldquo;{itemName}&rdquo;
            </span>
            ?
          </p>
          <p className="text-sm text-gray-500 dark:text-gray-500">{warning}</p>
        </div>

        <div className="flex gap-3 pt-2">
          <Button
            variant="secondary"
            onClick={onClose}
            className="flex-1 px-6 py-3 font-medium"
            disabled={isDeleting}
          >
            {t('common.cancel')}
          </Button>
          <Button
            variant="danger"
            onClick={onConfirm}
            className="flex-1 px-6 py-3 font-medium"
            disabled={isDeleting}
          >
            <span className="material-icons text-sm mr-2">{icon}</span>
            {confirmLabel}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
